import { render, staticRenderFns } from "./DownloadCandidateProfile.vue?vue&type=template&id=16a43c40"
import script from "./DownloadCandidateProfile.vue?vue&type=script&lang=js"
export * from "./DownloadCandidateProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports